export default function languageSelectorFunctionality() {
  const $languageButtons = $('nav.lang button.language-switcher');
  const $languageSelectors = $('nav.lang ul.languages');

  function toggleSelector(e) {
    e.preventDefault();
    e.stopPropagation();

    const $button = $(this);
    const $selector = $button.closest('nav.lang').find('ul.languages');
    const isHeader = $button.closest('header').length > 0;
    const activeClass = isHeader ? 'active-header' : 'active-footer';

    const isAlreadyActive = $selector.hasClass(activeClass);

    $languageSelectors.removeClass('active-header active-footer');
    $languageButtons.attr('aria-expanded', 'false');

    if (!isAlreadyActive) {
      $selector.addClass(activeClass);
      $button.attr('aria-expanded', 'true');
    }
  }

  function hideSelectors() {
    $languageSelectors.removeClass('active-header active-footer');
    $languageButtons.attr('aria-expanded', 'false');
  }

  $languageButtons.on('click', toggleSelector);

  $(document).on('click', function (e) {
    if (!$(e.target).closest('nav.lang').length) {
      hideSelectors();
    }
  });
}
